module.exports = __webpack_public_path__ + "img/dashboard.6a61b681.png";